import React, { useState, useEffect } from 'react';
import ScrollProgressBar from 'react-scroll-progress-bar';
import Footer from '../pages/Footer';
import '../css/About.css';
import GoToTopButton from '../pages/GoToTopButton';

const About = () => {
  return (
    <div>
       <ScrollProgressBar height="5px" color="#007bff" duration="0.2" />
       <GoToTopButton />

      <section style={styles.container}>
      <div style={styles.header}>
          <h1>About Us</h1>
          <p>We are a passionate team of creators.</p>
        </div>

        <div style={styles.content}>
          <h2>Our Mission</h2>
          <p>
            Our mission is to inspire and empower people through innovative
            projects. We believe in the power of technology and creativity to
            make a positive impact on the world.
          </p>
        </div>

        <div style={styles.content}>
          <h2>Our Vision</h2>
          <p>
            Our vision is to become a hub for showcasing outstanding projects
            and connecting talented individuals. We aim to foster collaboration
            and learning within our community.
          </p>
        </div>

        {/* Add your custom content here */}
        <div style={styles.content}>
         
        </div>

        <div style={styles.content}>
    
        </div>
      </section>
      <Footer />
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  content: {
    marginBottom: '40px',
  },
};

export default About;
